(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/nav-menu/assets/javascripts/bingo-nav-menu.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/nav-menu/assets/javascripts/bingo-nav-menu.js');
"use strict";


const _ReactRouterDOM = ReactRouterDOM,
  Link = _ReactRouterDOM.Link,
  useLocation = _ReactRouterDOM.useLocation;
const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  IconItem = _svs$ui$ReactItemsMen.IconItem;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const BingoNavMenu = _ref => {
  let routes = _ref.routes;
  const location = useLocation();
  const isSmallScreen = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const activeRoutes = routes.filter(route => route.active);
  return React.createElement(ItemsMenu, {
    ariaLabel: "Meny f\xF6r Bingo",
    branding: "bingo",
    centered: true,
    className: "js-bingo-items bingo-nav",
    compact: isSmallScreen
  }, activeRoutes.map(route => {
    const selected = location.pathname === "/".concat(route.path) || location.pathname === '/' && route.path === 'spela';
    return React.createElement(IconItem, {
      alignment: isSmallScreen ? 'vertical' : 'horizontal',
      className: "bingo-nav__link",
      Component: Link,
      "data-testid": "bingo-route",
      gutter: 1,
      iconName: route.icon,
      isSelected: selected,
      key: route.path,
      label: isSmallScreen && route.shortLabel || route.label,
      to: route.path
    });
  }));
};
setGlobal('svs.bingo_react.components.nav_menu.BingoNavMenu', BingoNavMenu);

 })(window);